<div class="offerwrapper acvis-elevation" (dragover)="dragOver($event)" (drop)="dropp($event)">
    <div class="offerheader">
        <span multilang class="offerheadertext"><b>Angebot Nr. {{index()}}</b> {{datas?.productType}}</span>
        <ng-container *ngIf="currentCustomer?.asPartner">
            <div class="actions">
                <mat-icon class="rmico mr3" (click)="openSetComment()" matTooltip="Extra info">
                    comment
                </mat-icon>
                <button [draggable]="true" class="drg mr3" matTooltip="Position ändern"
                    (dragstart)="dragStart($event, index())">
                    <svg _ngcontent-soh-c164="" width="24px" fill="currentColor" viewBox="0 0 24 24">
                        <path _ngcontent-soh-c164=""
                            d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
                        </path>
                        <path _ngcontent-soh-c164="" d="M0 0h24v24H0z" fill="none"></path>
                    </svg>
                </button>
                <mat-icon class="rmico" (click)="removeFromListF()" matTooltip="Angebot löchen">
                    cancel
                </mat-icon>
            </div>
        </ng-container>
    </div>
    <div class="offerbody">
        <div class="offerimgwrapper">
            <ng-container *ngIf="images?.length > 0">
                <imageslider (clickOnImg)="openImageModal($event)" [showcounter]="false" [current]="0" [data]="images"
                    class="offerimg">
                </imageslider>
            </ng-container>
            <div class="bookingcardheader">
                <div class="hotelnamewrapper" style="width: 100%;">
                    <span multilang>
                        <mat-icon *ngFor="let cat of categoryAr;" class="infoc">
                            {{cat === 1 ? 'star':'star_half'}}
                        </mat-icon>
                    </span>
                    <span multilang class="bold ellipsis" style="width: 95%;">{{myhotel?.name}}</span>
                    <span multilang class="locationsize">
                        {{myhotel?.region?.[0]?.name}},
                        {{myhotel?.region?.[0]?.country?.country_name}}
                    </span>
                </div>
            </div>
        </div>

        <div class="offerOperator" [style.background-color]="online()?.length > 0 ? '#ace59f': ''">
            <span multilang style="font-weight: 500;">Ratehawk</span>
        </div>
        <div class="offerschedule">
            <mat-icon class="unsetico">event</mat-icon>
            <span multilang class="offerscheduletext">
                <b>{{(dauer() | number:'1.0-0') + (dauer() === '1' ? ' Nacht' : ' Nächte')}}</b>
                {{datas?.filter?.checkin | date:'dd.MM.yyyy'}} - {{datas?.filter?.checkout | date:'dd.MM.yyyy'}}
            </span>
        </div>
        <div class="offerinfos">
            <div class="infobody">
                <div class="offerinfodet">
                    <mat-icon class="infoc">bedroom_child</mat-icon>
                    <span multilang class="cc21">{{datas?.filter?.guests?.length}} x
                        {{datas?.prc?.room_name}}</span>
                </div>

                <div class="offerinfodet"
                    [style.color]="myprice?.meal?.indexOf('breakfast') >= 0 || myprice?.meal?.indexOf('half-board') >= 0 ? '#008900': ''">
                    <mat-icon class="infoc">dining</mat-icon>
                    @if(myprice?.meal === 'nomeal') {
                    <span multilang class="cc21">Keine Mahlzeiten</span>
                    } @else if(myprice?.meal?.indexOf('breakfast') >= 0){
                    <span multilang class="cc21">Frühstück inbegriffen</span>
                    } @else if(myprice?.meal?.indexOf('half-board') >= 0){
                    <span multilang style="width: calc(100% - 30px);word-break: break-all;">Frühstück und
                        Abendessen
                    </span>
                    }
                </div>


                <div class="offerinfodet"
                    [style.color]="myprice?.cancellation_penalties?.free_cancellation_before?.length > 0? '#008900': ''">
                    <mat-icon class="infoc">undo</mat-icon>
                    @if(myprice?.cancellation_penalties?.free_cancellation_before?.length
                    > 0) {
                    <span multilang class="cc21">Kostenlose Stornierung</span>
                    } @else {
                    <span multilang class="cc21">Kein Gratis-Storno</span>
                    }
                </div>


            </div>
            <button class="offerinfodet" (click)="openDetail()">
                <span multilang class="minbtn noselect" matRipple>Mehr Details</span>
            </button>
        </div>
        <div class="offerprice">
            <span multilang>
                <span multilang>Erwachsene : {{adults()}}</span>
                @if(child() > 0) {
                <span multilang style="margin-left: .5rem;">Kinder :
                    {{child()}}</span>
                }
            </span>
            <div class="offerpriceTotal">
                <span multilang>Gesamtpreis:</span>
                <span multilang class="prccolor">{{myprice?.payment_options?.payment_types?.[0]?.show_amount |
                    number:'1.2-2'}}
                    {{myprice?.payment_options?.payment_types?.[0]?.show_currency_code}}</span>
            </div>
        </div>
        <button class="mhrd" (click)="gotoBuchen();">
            <div class="noselect bookingbtn">
                Buchen
            </div>
        </button>
    </div>
</div>

<ng-container *ngIf="showDetail">
    <clever-offerpackdetailmodal (triggerCloseModal)="closeModal($event)" [cmpRef]="component">
    </clever-offerpackdetailmodal>
</ng-container>